<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<path d="M11,9H9v2H1V3h2V1h8V9z M8,4H2v6h6V4z M10,2H4v1h5v5h1V2z" />
</svg>
</template>